import "firebase/auth";
import { useState } from "react";
import { auth } from "../config";

import { Box, Button, Card, CardContent, Tab, Tabs, TextField, Typography } from "@material-ui/core";

import { Link } from "react-router-dom";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";

const Auth = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [passwordRepeat, setPasswordRepeat] = useState("");
    const [name, setName] = useState("");
    const [message, setMessage] = useState("");

    const location = useLocation();
    const history = useHistory();

    const queryParams = new URLSearchParams(location.search);
    const tab = parseInt(queryParams.get("tab") || "0");

    const handleTabChange = (_, newValue) => {
        setMessage("");

        const params = new URLSearchParams(location.search);
        params.set("tab", newValue);

        history.replace({
            pathname: location.pathname,
            search: params.toString()
        });
    };

    const passwordsDontMatch = tab === 1 && passwordRepeat.length > 0 && password !== passwordRepeat;

    const signIn = async () => {
        setMessage("");
        try {
            await auth.signInWithEmailAndPassword(email, password);
        } catch (err) {
            if (err.code === "auth/user-not-found") setMessage("Brugeren findes ikke");
            else setMessage(err.message);
        }
    };

    const signUp = async () => {
        setMessage("");
        if (passwordsDontMatch) {
            setMessage("Kodeord matcher ikke");
            return;
        }

        try {
            await auth.createUserWithEmailAndPassword(email, password);

            if (name && auth.currentUser) {
                await auth.currentUser.updateProfile({
                    displayName: name
                });
            }
        } catch (err) {
            setMessage(err.message);
        }
    };

    const resetPassword = async () => {
        setMessage("");
        try {
            await auth.sendPasswordResetEmail(email);
            setMessage("Vi har sendt en email med et link til at vælge et nyt kodeord");
        } catch (err) {
            setMessage(err.message);
        }
    };

    return (
        <Box display="flex" justifyContent="center" mt={6} px={2}>
            <Card style={{ width: "50%" }}>
                <CardContent>
                    <Tabs
                        value={tab}
                        onChange={handleTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth">
                        <Tab label="Log ind" />
                        <Tab label="Opret" />
                        <Tab label="Glemt kode" />
                    </Tabs>

                    <Box mt={2}>
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Email"
                            type="email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                        />

                        {tab === 1 && (
                            <TextField
                                fullWidth
                                margin="normal"
                                label="Kaldenavn"
                                type="text"
                                value={name}
                                onChange={e => setName(e.target.value)}
                            />
                        )}

                        {(tab === 0 || tab === 1) && (
                            <TextField
                                fullWidth
                                margin="normal"
                                label="Kodeord"
                                type="password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                            />
                        )}

                        {tab === 1 && (
                            <TextField
                                fullWidth
                                margin="normal"
                                label="Gentag kodeord"
                                type="password"
                                value={passwordRepeat}
                                onChange={e => setPasswordRepeat(e.target.value)}
                                error={passwordsDontMatch}
                                helperText={passwordsDontMatch ? "Kodeord matcher ikke" : ""}
                            />
                        )}

                        <Box mt={2}>
                            {tab === 0 && (
                                <Button variant="contained" color="primary" fullWidth onClick={signIn}>
                                    Log ind
                                </Button>
                            )}

                            {tab === 1 && (
                                <Button variant="contained" color="primary" fullWidth onClick={signUp}>
                                    Opret konto
                                </Button>
                            )}

                            {tab === 2 && (
                                <Button variant="contained" color="primary" fullWidth onClick={resetPassword}>
                                    Vælg ny kode
                                </Button>
                            )}
                        </Box>

                        {message && <Typography style={{ marginTop: 12, color: "red" }}>{message}</Typography>}
                        <Box mt={3} display="flex" justifyContent="center" style={{ gap: 16 }}>
                            <Typography variant="body2">
                                <Link to="/PrivacyPolicy">Privatlivspolitik</Link>
                            </Typography>

                            <Typography variant="body2">
                                <Link to="/TermsOfUse">Vilkår</Link>
                            </Typography>

                            <Typography variant="body2">
                                <Link to="/CookiePolicy">Cookies</Link>
                            </Typography>
                        </Box>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
};

export default Auth;
